<div *ngIf="showUpdateNotification" class="update-notification">
  <div class="update-notification-content">
    <div class="update-icon">
      <i data-feather="refresh-cw"></i>
    </div>
    <div class="update-text">
      <strong>Nouvelle version disponible!</strong>
      <span>Une mise à jour de l'application est prête à être installée.</span>
    </div>
    <div class="update-actions">
      <button class="btn btn-sm btn-outline-light mr-50" (click)="dismissNotification()">
        Plus tard
      </button>
      <button class="btn btn-sm btn-light" (click)="updateApp()">
        <i data-feather="download" class="mr-25"></i>
        Mettre à jour
      </button>
    </div>
  </div>
</div>
